import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import municipalities from '../data/municipios-brasil.json';

const normalize = (value) => String(value || '')
  .replace(/[\s]*[-–,][\s]*[a-z]{2}$/i, '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLocaleLowerCase('pt-BR');

const CITY_OPTIONS = municipalities.map(({ name, uf }) => `${name} - ${uf}`);

export default function CityAutocomplete({ value, onChange, textFieldProps = {}, ...autocompleteProps }) {
  const cityValue = value || '';
  return (
    <Autocomplete
      freeSolo
      options={CITY_OPTIONS}
      value={cityValue || null}
      inputValue={cityValue}
      onChange={(_, selected) => onChange(selected || '')}
      onInputChange={(_, input, reason) => {
        if (reason === 'input' || reason === 'clear') onChange(input);
      }}
      filterOptions={(options, state) => {
        const query = normalize(state.inputValue);
        if (query.length < 2) return [];
        return options.filter((option) => normalize(option).includes(query)).slice(0, 8);
      }}
      getOptionLabel={(option) => typeof option === 'string' ? option : ''}
      renderInput={(params) => <TextField {...params} {...textFieldProps} />}
      {...autocompleteProps}
    />
  );
}
